<template>
  <q-btn
    v-ripple="false"
    :class="{'dense-button': dense, 'full-width': fullWidth, 'dashed-button': dashed}"
    :color="color"
    :padding="padding"
    :size="size"
    :text-color="textColor"
    :type="type"
    :align="align"
    class="text-no-wrap no-wrap"
    unelevated
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <q-icon
      v-if="iconLeft"
      :size="iconLeftSize"
      :color="iconLeftColor"
      :name="iconLeft"
    />
    <div
      v-if="label"
      :class="labelClass"
    >
      {{ label }}
    </div>
    <slot v-if="$slots.default"/>
    <q-icon
      v-if="iconRight"
      class="q-ml-xs"
      :color="iconRightColor"
      :name="iconRight"
      :size="iconRightSize"
    />
  </q-btn>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    label: {
      type: String,
      default: undefined,
    },
    labelClass: {
      type: String,
      default: 'q-px-xs',
    },
    align: {
      type: String,
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    dashed: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: undefined,
    },
    iconLeftSize: {
      type: String,
      default: undefined,
    },
    iconLeft: {
      type: String,
      default: undefined,
    },
    iconLeftColor: {
      type: String,
      default: undefined,
    },
    iconRight: {
      type: String,
      default: undefined,
    },
    iconRightSize: {
      type: String,
      default: undefined,
    },
    iconRightColor: {
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      default: 'primary',
    },
    textColor: {
      type: String,
      default: undefined,
    },
    padding: {
      type: String,
      default: '14px 22px',
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .q-btn {
    &--outline {

      ::v-deep .q-btn__content {

        span {
          padding: 0 10px;
        }
      }
    }
  }
}

.dashed-button {
  ::v-deep .q-focus-helper {
    opacity: 0 !important;

    &::before,
    &::after {
      opacity: 0 !important;
    }
  }

  &:hover {
    color: $accent !important;

    ::v-deep .q-btn {
      &__wrapper {
        &:before {
          border-color: $accent !important;
        }
      }
    }
  }

  ::v-deep .q-btn {
    &__wrapper {
      &:before {
        border: 1px dashed currentColor;
      }
    }
  }
}

.dense-button {
  ::v-deep .q-btn {
    &__content span {
      padding: 0 4px !important;
    }

    &__wrapper {
      padding: 6px 12px !important;
    }
  }
}

.q-btn {
  &--outline {
    ::v-deep .q-btn__wrapper {
      &:before {
        border: 1px solid $grey-2;
      }
    }
    ::v-deep .q-btn__content {
      span {
        font-weight: 500;
      }

      display: flex;
      flex-wrap: nowrap;
      white-space: nowrap;
    }
  }

  text-transform: none !important;
  font-size: 17px;
  font-weight: 700;
  border-radius: $radius-6;

  &[disabled] {
    opacity: 1 !important;
    background-color: $grey-3 !important;
    color: $grey-1 !important;
    font-weight: 400 !important;
  }

  ::v-deep .q-btn__content {

    span {
      //padding: 0 24px;
      //margin: 0 auto;
    }

    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  ::v-deep .q-icon {
    display: flex;
    font-size: 20px;
  }
}
</style>
